import axios, { InternalAxiosRequestConfig } from 'axios';
import { facebookRequest } from '@php-beam/packages/frontend/src/support/facebook';

export const CLIENT_URL_HEADER = 'X-Client-Url';

/** The page the user is on, without the fragment a browser never sends as a Referer. */
export const currentPageUrl = (): string => {
  const { href, hash } = window.location;

  return href.slice(0, href.length - hash.length);
};

/**
 * The server sends redirects back to the Referer, and some browsers send one that is not the page
 * the request came from, which landed clients on the staff login (HD-5989). Telling the server the
 * page explicitly keeps those redirects on it. Only sent to this site, since another origin would
 * turn the header into a CORS preflight.
 */
export const sendClientUrl = (
  config: InternalAxiosRequestConfig,
): InternalAxiosRequestConfig => {
  try {
    const target = new URL(
      config.url ?? '',
      config.baseURL ?? window.location.href,
    );

    if (target.origin === window.location.origin) {
      config.headers.set(CLIENT_URL_HEADER, currentPageUrl());
    }
  } catch {
    // A URL that cannot be parsed is sent as it is.
  }

  return config;
};

export const client = axios.create({
  baseURL: import.meta.env.VITE_URL,
});

client.interceptors.request.use(sendClientUrl);

export const facebookClient = {
  get: <T extends object>(path: string, params: Record<string, string> = {}) =>
    facebookRequest<T>(path, 'get', params),
  post: <T extends object>(path: string, params: Record<string, string> = {}) =>
    facebookRequest<T>(path, 'post', params),
  delete: <T extends object>(
    path: string,
    params: Record<string, string> = {},
  ) => facebookRequest<T>(path, 'delete', params),
};
